import { dataArrowToTop } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowToTop = /*#__PURE__*/createIcon(dataArrowToTop)
export default IconArrowToTop
